export default "__VITE_ASSET__QcgEp50x__"